// extracted by mini-css-extract-plugin
export default {"deviceButton":"HangUpButton_deviceButton__KfYhH","icon":"HangUpButton_icon__ALv-X"};